// RootLayout.jsx
import React from "react"
import { getThemeStylesheet } from "../utils/filters/build"

const RootLayout = ({ children, themeName }) => {
  const theme = getThemeStylesheet(themeName)

  return (
    <div data-theme={theme} className="mx-auto">
      <div className="max-w-[1250px] mx-auto px-2">{children}</div>
    </div>
  )
}

export default RootLayout
